import { mapActions } from 'vuex';

import bus from '@/utils/bus';

export default {
  name: 'MenuSidebar',
  props: {
    show: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    list() {
      return [
        {
          hoverIcon: 'icon-group-buying-white',
          icon: 'icon-group-buying',
          title: '訂購首頁',
          to: '/menu',
        },
        {
          hoverIcon: 'icon-document-white',
          icon: 'icon-document',
          title: '歷史訂單',
          to: '/orders',
        },
        {
          hoverIcon: 'icon-member-white',
          icon: 'icon-member',
          title: '個人資訊',
          to: '/user',
        },
      ];
    },
  },
  created() {
    window.addEventListener('click', (e) => this.clickInTarget(e));
  },
  destroyed() {
    window.removeEventListener('click', (e) => this.clickInTarget(e));
  },
  methods: {
    ...mapActions({
      resetState: 'reset',
    }),
    clickInTarget(e) {
      const inSidebar = document.getElementById('menu-sidebar')?.contains(e.target);
      const onOpenMenuButton = document.getElementById('open-menu')?.contains(e.target);

      if (!inSidebar && !onOpenMenuButton) {
        this.close();
      }
    },
    close() {
      this.$emit('close');
    },
    goPage(to) {
      if (this.$route.path === to) {
        return;
      }
      this.$router.push(to);
      this.$emit('close');
    },
    logout() {
      localStorage.clear();
      this.resetState();
      this.close();
      bus.$emit('CLEAR_TEMP_COMPANY_NAME');
      // TODO: User router.push after router error fixed
      // this.$router.push('/login');
      window.location.href = '/login';
    },
  },
};
